import { QuickQuoteConfig } from 'contexts/serviceContext';
import { Maybe } from 'types/UtilityTypes';
import QuickQuoteReplyActionMode from 'types/enums/QuickQuoteReplyActionMode';

const QUICK_QUOTE_REPLY_ACTION_MODES = new Set<string>(
  Object.values(QuickQuoteReplyActionMode)
);

function isQuickQuoteReplyActionMode(
  value: unknown
): value is QuickQuoteReplyActionMode {
  return typeof value === 'string' && QUICK_QUOTE_REPLY_ACTION_MODES.has(value);
}

// Explicit known quickQuoteReplyActionMode wins; unknown values fall through.
// Legacy isQuickQuoteSendReplyEnabled maps to send_primary.
export function getQuickQuoteReplyActionMode(
  quickQuoteConfig: Maybe<
    Pick<
      QuickQuoteConfig,
      'quickQuoteReplyActionMode' | 'isQuickQuoteSendReplyEnabled'
    >
  >
): QuickQuoteReplyActionMode {
  if (
    isQuickQuoteReplyActionMode(quickQuoteConfig?.quickQuoteReplyActionMode)
  ) {
    return quickQuoteConfig.quickQuoteReplyActionMode;
  }

  if (quickQuoteConfig?.isQuickQuoteSendReplyEnabled === true) {
    return QuickQuoteReplyActionMode.SendPrimary;
  }

  return QuickQuoteReplyActionMode.DraftPrimary;
}
